import { LatLng } from 'leaflet';
import { DrawRotatedRectangle } from '../components/DrawControl.models/Draw.rotatedRectangle';
import { IUndoRedoCommand } from './undoRedoCommand';

export class AddRotatedRectangleVertexCommand implements IUndoRedoCommand {
  private readonly polygon: DrawRotatedRectangle;
  private readonly latlng: LatLng;

  constructor(polygon: DrawRotatedRectangle, latlng: LatLng) {
    this.polygon = polygon;
    this.latlng = latlng;
  }

  executeUndo(): void {
    if (this.polygon.getMarkersCount() > 1) {
      this.polygon.deleteLastVertex();
    } else {
      this.polygon.disable();
      this.polygon.enable();
    }
  }

  executeRedo(): void {
    this.polygon.addVertex(this.latlng);
  }
}
